import { deleteTokens } from "@/utils/functions/cookieOperations";
import { useAtom } from "jotai";
import { isSignedInAtom } from "./authAtoms";
import { useCallback } from "react";
import { latestViewedProductsAtom } from "./productAtoms";
import { RESET } from "jotai/utils";
import { exchangeAtom } from "./exchangeAtom";

export const useLogout = () => {
  const [, setSignedIn] = useAtom(isSignedInAtom);
  const [, setLatestViewed] = useAtom(latestViewedProductsAtom);
  const [, setExchangeData] = useAtom(exchangeAtom);
  const logout = useCallback(() => {
    deleteTokens();
    setSignedIn(false);
    setLatestViewed(RESET);
    setExchangeData(null);
  }, [setSignedIn, setLatestViewed, setExchangeData]);

  return { logout };
};
